/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import injectReducer from '../../../../utils/injectReducer';
import CreditStatus from '../../../../components/Web/CreditStatus/redesign/index';
import { getCreditHoldResponse } from '../../../../services/Cart/selectors/cartSelectors';
import * as Action from '../../actions';
import * as cartActions from '../../../../services/Cart/actions';
import creditStatus from '../../reducer';
import * as taggingActions from '../../../Common/Tagging.js/actions';
import cartSaga from '../../../../services/Cart/sagas';
import injectSaga from '../../../../utils/injectSaga';
import taggingSaga from '../../../Common/Tagging.js/sagas';

const mapStateToProps = (state) => {
  const creditHoldContent = getCreditHoldResponse(state.cartDetails);
  const validateOrder = state.cartDetails?.validateOrder || {};
  const currentView = state.currentView || {};
  const validatedHoldOrder = state.creditStatus?.validatedCreditHold;
  const creditStatusLanded = state.creditStatus?.creditStatusLanded;
  const creditAppNum = validateOrder?.orderDetails?.[0]?.creditApplicationNum || 'NAN';
  const cartDetails = state.cartDetails || {};
  const apiLoaded = state.SessionValues?.apiLoaded;
  const taggingApiLoaded = state.SessionValues?.taggingApiLoaded || false;
  return {
    creditHoldContent,
    validateOrder,
    currentView,
    validatedHoldOrder,
    creditAppNum,
    creditStatusLanded,
    cartDetails,
    apiLoaded,
    taggingApiLoaded,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...Action, ...cartActions, ...taggingActions }, dispatch);
}
const withReducer = compose(injectReducer({ key: 'creditStatus', reducer: creditStatus }));

const withSaga = compose(
  injectSaga({ key: 'cartDetails', saga: cartSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
);

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default withRouter(
  compose(
    withSaga,
    withReducer,
    withConnect,
  )(CreditStatus),
);
